import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { CreateFeedbackPayload } from '@app/utils/interfaces/system-feedback.interface';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  public createFeedback(payload: CreateFeedbackPayload): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}${ApiEndpoints.FEEDBACK}`, payload);
  }
}
